// v-overflow-title
// Toont de volledige tekst als native tooltip (title), maar alléén wanneer
// de tekst daadwerkelijk is afgekapt met ellipsis (scrollWidth > clientWidth).
// De check gebeurt bij mouseenter, zodat ook na resizen de juiste staat geldt.
//
// Gebruik:  <span class="th-label" v-overflow-title>Lange headertekst</span>
// Optioneel met expliciete tekst:  v-overflow-title="'Volledige tekst'"
const overflowTitle = {
  mounted(el, binding) {
    el.__overflowTitleHandler = () => {
      if (el.scrollWidth > el.clientWidth) {
        el.setAttribute('title', binding.value || el.textContent.trim())
      } else {
        el.removeAttribute('title')
      }
    }
    el.addEventListener('mouseenter', el.__overflowTitleHandler)
  },
  unmounted(el) {
    el.removeEventListener('mouseenter', el.__overflowTitleHandler)
    delete el.__overflowTitleHandler
  }
}

export default overflowTitle
